import type { App } from 'vue'

import scrollLoad from './scrollLoad'

export const registerDirectives = (app: App) => {
  app.directive('scroll-load', scrollLoad)
}

export default registerDirectives
